import React, { useMemo, lazy, Suspense } from 'react';
export default function Builder(_ref) {
  var appProps = _ref.appProps;
  var BuilderV1 = /*#__PURE__*/lazy(function () {
    return import('./Content');
  });
  var BuilderV2 = /*#__PURE__*/lazy(function () {
    return import('@reactiveonline/reactive_builder_parser');
  });
  var newBuilderEnabled = appProps.newBuilderEnabled;
  var builderContent = useMemo(function () {
    return /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement("div", null)
    }, newBuilderEnabled && /*#__PURE__*/React.createElement(BuilderV2, {
      contentUrl: appProps.builderData.contentUrl,
      googleCloudBucket: appProps.builderData.googleCloudBucket,
      settings: appProps.builderData.settings,
      extraData: appProps
    }), !newBuilderEnabled && /*#__PURE__*/React.createElement(BuilderV1, {
      appProps: appProps
    }));
  }, []);
  return builderContent;
}